import { render, staticRenderFns } from "./controllerYm.vue?vue&type=template&id=22620879&scoped=true&"
import script from "./controllerYm.vue?vue&type=script&lang=js&"
export * from "./controllerYm.vue?vue&type=script&lang=js&"
import style0 from "./controllerYm.vue?vue&type=style&index=0&id=22620879&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22620879",
  null
  
)

export default component.exports